<template>
  <div class="flex flex-col" :class="groupClass">
    <SelectComponent
      v-model="selectedIds"
      multiple
      :values="options"
      :searchable="searchable"
      :label="label"
      :placeholder="placeholder ?? label"
      :track-by="trackBy"
      :display-key="attributeLabel"
      :disabled="disabled"
      :required="required"
      :name="name"
    />
    <ErrorContainer v-if="errors" :error-key="name" :errors="errors" />
  </div>
</template>

<script>
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

/**
 * Multiple select with the former package's contract, which Crema's filters
 * rely on: starts from `defaultValue` (selected option objects) and emits
 * `setSelected` with `{ value: [option objects], attribute: name }`. It also
 * supports `v-model` on the selected ids.
 *
 * Funeral Manager's BaseSelectMultiple is not used: it shows `attributeLabel`
 * as its label and emits a broken `attribute`.
 */
export default {
  name: 'BaseSelectMultiple',
  components: { SelectComponent, ErrorContainer },
  props: {
    name: { type: String, required: true },
    label: { type: String, required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    groupClass: { type: String, required: false, default: '' },
    errors: { type: [Object, Array], required: false, default: null },
    options: { type: Array, required: true },
    modelValue: { type: Array, required: false, default: undefined },
    defaultValue: { type: Array, required: false, default: () => [] },
    trackBy: { type: String, required: false, default: 'id' },
    attributeLabel: { type: String, required: false, default: 'name' },
    disabled: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    searchable: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue', 'setSelected', 'change'],
  data() {
    return {
      internalIds: (this.defaultValue ?? [])
        .filter(Boolean)
        .map((option) =>
          typeof option === 'object' ? option[this.trackBy] : option
        )
    }
  },
  computed: {
    selectedIds: {
      get() {
        return this.modelValue !== undefined
          ? this.modelValue
          : this.internalIds
      },
      set(ids) {
        this.internalIds = ids ?? []
        const selected = this.options.filter((option) =>
          this.internalIds.includes(option[this.trackBy])
        )
        this.$emit('update:modelValue', this.internalIds)
        this.$emit('change', this.internalIds)
        this.$emit('setSelected', { value: selected, attribute: this.name })
      }
    }
  }
}
</script>
